import React from 'react';
import ContentLoader from 'react-content-loader';

const HeaderSkeleton: React.FC = () => (
  <ContentLoader
    speed={1}
    width={150}
    height={40}
    opacity={0.7}
    backgroundColor="#e0e0e0"
    foregroundColor="#c8c8c8"
    style={{
      display: 'block'
    }}
  >
    <circle cx="20" cy="20" r="20" />

    <rect x="50" y="10" rx="4" ry="4" width="100" height="20" />
  </ContentLoader>
);

export default HeaderSkeleton;
